import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;
    height: 100%;
`;

export const Content = styled.div`
    flex: .9;
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const ContentOrder = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;

    height: 80%;

    @media (max-width: 900px) {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const Footer = styled.footer`
    display: flex;
    justify-content: flex-end;

    div{
        display: flex;
        gap: 15px;
    }
`;

export const ContentButton = styled.div`
    display: flex;
    gap: 8px;
`;

